import { useCallback } from 'react';

import { useToasts } from '@air/provider-toast';

import { useCopied } from '~/hooks/useCopied';

export const useCopyLinkToClipboard = () => {
  const { showToast } = useToasts();
  const { copied, markCopied } = useCopied();

  const copyLinkToClipboard = useCallback(
    async (url: string, onSuccess?: (url: string) => void) => {
      try {
        await window.navigator.clipboard.writeText(url);
        markCopied();
        onSuccess?.(url);
      } catch {
        showToast('Failed to copy link', { color: 'red' });
      }
    },
    [markCopied, showToast],
  );

  return { copyLinkToClipboard, copied };
};
